import { authFetchInit } from "../../../../utils/csrf";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { CommonToast } from "../../../common/Toast";
import { saveLastRoute, showLoginModal } from "../../../../store/auth/authSlice";

/* Save Business as PDF. TRANSCRIBED from BannerCompanyCard's handleDownload/exporttoPDF: the same endpoint, the same blob-to-anchor download, the same... */

/* Transcribed verbatim from BannerCompanyCard's local sanitizeFilename: every character outside [A-Za-z0-9._-] becomes an underscore, runs of underscores... */
export const sanitizeFilename = (name) =>
  name
    ?.replace(/[^a-zA-Z0-9._-]/g, "_")
    ?.replace(/_+/g, "_")
    ?.substring(0, 100) || "download";

export const pdfFileName = (company) => {
  const raw = company?.registered_company_name || company?.company?.name;
  return `${sanitizeFilename(raw) || "document"}.pdf`;
};

export const exportPdfUrl = (id) => `/api/company/export-pdf/${id}/pdf/`;

export const useProfileExport = (company) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [exporting, setExporting] = useState(false);

  const exportPdf = async () => {
    /* Transcribed guard: one export at a time. */
    if (exporting) return;
    setExporting(true);
    CommonToast.info("PDF generation started, it will download shortly.");

    let objectUrl;
    try {
      const response = await fetch(exportPdfUrl(id), authFetchInit({
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }));

      /* A dead session is the common failure and has its own recovery — the
         same one every other call gets from baseQueryWithReauth. */
      if (response.status === 401) {
        dispatch(saveLastRoute(window.location.pathname));
        dispatch(showLoginModal());
        return;
      }

      if (!response.ok) throw new Error(`Export failed (${response.status})`);

      const blob = await response.blob();
      objectUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = pdfFileName(company);
      document.body.appendChild(link);
      link.click();
      link.remove();

      CommonToast.success("PDF download started.");
    } catch (error) {
      /* Says which step failed rather than the live version's flat message. */
      CommonToast.error(
        error?.message?.startsWith("Export failed")
          ? `Couldn't build the PDF. ${error.message}`
          : "Couldn't download the PDF. Please try again."
      );
    } finally {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
      setExporting(false);
    }
  };

  return { exporting, exportPdf };
};

export default useProfileExport;
